import { connect } from "react-redux";
import PremierUnavailableMessage from "../../components/PremierUnavailableMessage/index.jsx";

const mapStateToProps = (state) => ({
  premierAvailable: state.CountrySelector.premierAvailable,
  premierDeliveryUnavailableText:
    state.PremierPageFrame.content.premierDeliveryUnavailable,
});

export default connect(mapStateToProps)(PremierUnavailableMessage);
